<template>
  <canvas id="canvas" :class="{'is-circle' : layout === 'circle'}"></canvas>
</template>

<script>
import Canvas from '../scripts/Canvas'

export default {
  props: {
    layout: String,
    modus: String,
    settings: Object,
    running: String
  },
  data: function () {
    return {
      parent: document.getElementById('content'),
      status: {
        init: false,
        delay: null
      },
      canvas: null
    }
  },
  methods: {
    initCanavas: function () {
      this.canvas = new Canvas(document.getElementById('canvas'), this.modus, this.settings)
      if (this.canvas) this.canvas.setDemension(this.layout, this.parent.clientWidth, this.parent.clientHeight)
    }
  },
  watch: {
    running: function () {
      if (!this.status.init) return
      if (this.running === 'r') {
        this.canvas.startAnimation()
      } else if (this.running === 'p') {
        this.canvas.pauseAnimation()
      } else if (this.running === 's') {
        this.canvas.stopAnimation()
      }
    },
    layout: function () {
      if (this.canvas) this.canvas.setDemension(this.layout, this.parent.clientWidth, this.parent.clientHeight)
    },
    modus: async function () {
      if (this.running === 'r') await this.canvas.stopAnimation()
      this.canvas.setModus(this.modus, this.settings)
      if (this.running === 'r') {
        this.canvas.startAnimation()
      } else if (this.running === 'p') {
        this.canvas.pauseAnimation()
      } else if (this.running === 's') {
        this.canvas.stopAnimation()
      }
    },
    settings: {
      handler: function () {
        clearTimeout(this.status.delay)
        this.status.delay = setTimeout(() => { this.canvas.setSettings(this.settings) }, 100)
      },
      deep: true
    }
  },
  mounted: function () {
    this.parent = document.getElementById('content')
    window.addEventListener('resize', () => {
      if (this.running === 'r') this.canvas.pauseAnimation()
      if (this.canvas) this.canvas.setDemension(this.layout, this.parent.clientWidth, this.parent.clientHeight)
      clearTimeout(this.status.delay)
      this.status.delay = setTimeout(() => { if (this.running === 'r') this.canvas.startAnimation() }, 1000)
    })
    this.initCanavas()
    this.status.init = true
  }
}
</script>

<style lang="scss">
#canvas {
  margin: 0 auto;
  border: 4px solid #2e2e2e;
}
.is-circle {
  border-radius: 50%;
}
</style>>
